<div class="error-container">
  <mat-icon class="error-icon">{{ icon }}</mat-icon>
  <ng-container *ngIf="showText">
    <p class="error-message">{{ message }}</p>
  </ng-container>
</div>




